import Link from "next/link";
import Image from "next/image";
import { Search } from "lucide-react";
import LoadingSpinner from "@/components/LoadingSpinner";
import BannerSkeleton from "./_bannerSkeleton";

export default function HeaderSellerAcademySSR({ banner_count = 0 }) {
    return (
        <header dir="rtl" className="relative w-full bg-jmt-white">
            <div className="fixed top-0 right-0 left-0 z-40 bg-jmt-white">
                {banner_count > 0 && <BannerSkeleton count={banner_count} />}

                {/* Mobile */}
                <div className="border-b border-jmt-neutral-200 lg:hidden">
                    <div className="container">
                        <div className="flex w-full items-center justify-between gap-4 py-2.5">
                            <Link href="/seller-academy" className="flex shrink-0 h-6 w-auto">
                                <Image
                                    src="/images/logo/academy-logo.png"
                                    unoptimized
                                    alt="سلر آکادمی ژومنت"
                                    width={150}
                                    height={40}
                                    priority
                                    className="object-contain h-full w-auto"
                                />
                            </Link>

                            <div className="flex min-h-10 items-center justify-end gap-2">
                                <LoadingSpinner size={20} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Desktop */}
                <div className="hidden lg:block">
                    <div className="border-b border-jmt-neutral-100 py-4">
                        <div className="container">
                            <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center gap-4">
                                <Link href="/" className="justify-self-start text-sm font-bold text-jmt-primary-800 hover:text-jmt-primary-900">
                                    رفتن به فروشگاه ژومنت
                                </Link>

                                <Link href="/seller-academy" className="flex">
                                    <div className="w-[226px] h-10">
                                        <Image
                                            src="/images/logo/academy-logo.png"
                                            unoptimized
                                            alt="سلر آکادمی ژومنت"
                                            width={226}
                                            height={40}
                                            priority
                                            className="object-contain w-full h-full"
                                        />
                                    </div>
                                </Link>

                                <div className="flex min-h-[46px] items-center justify-end gap-4">
                                    <div className="flex h-10 w-10 shrink-0 items-center justify-center">
                                        <Search size={24} className="text-jmt-neutral-800" />
                                    </div>
                                    <LoadingSpinner size={20} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <nav className="flex items-center justify-center gap-6 py-4 border-b border-jmt-neutral-100">
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className="h-6 w-[110px] rounded-md bg-jmt-neutral-100" />
                        ))}
                    </nav>
                </div>
            </div>
        </header>
    );
}
